<template>
  <div>
    <Modal :title="title" v-model="modalShow" :footer-hide="!!link_data.length" width="600px">
      <div class="req-form">
        <Form ref="reqForm" :model="reqForm" style="padding-right: 10px" :rules="reqRule">
          <Alert type="error" v-show="errorMsgShow" show-icon>{{ errorMsg }}</Alert>
          <FormItem label="卷名称">
            <Input v-model="volumeData.name" :disabled="true" style="width: 300px" />
          </FormItem>
          <p style="color: #19be6b">已连接：</p>
          <Table
            size="small"
            highlight-row
            :loading="tableLoading"
            ref="table"
            :height="link_data.length > 7 ? 300 : 0"
            :data="link_data"
            :columns="link_columns">
          </Table>
          <br/>
          <FormItem label="连接到实例" prop="instance_uuid" v-if="!link_data.length">
            <Select v-model="reqForm.instance_uuid" transfer placeholder="请选择要连接的实例">
              <Option v-for="item in serverList" :key="item.id" :value="item.id">{{ item.name }} ({{ item.id }})</Option>
            </Select>
          </FormItem>
          <!--<FormItem label="挂载点" prop="mountpoint" v-if="!link_data.length">-->
            <!--<Input v-model="reqForm.mountpoint" placeholder="请填写挂载点，如：/dev/vdc" />-->
          <!--</FormItem>-->
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="submitting">提交</Button>
        <Button @click="modalShow = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { actionPrivateCloudVolume, detailPrivateCloudVolume } from '@/api/private-cloud/volume'
import { getPrivateCloudAllServer } from '@/api/private-cloud/server'
import { resourceIdTransName } from '@/view/private-cloud/cacheData'

export default {
  name: 'volume-extend',
  data () {
    return {
      title: '管理已连接卷',
      volumeData: {},
      modalShow: false,
      submitting: false,
      tableLoading: false,
      link_columns: [
        {
          title: '实例',
          align: 'center',
          minWidth: 150,
          tooltip: true,
          key: 'server_id',
          render: (h, params) => {
            return h('a', {
              on: {
                click: () => {
                  this.$router.push({ name: 'private_cloud_server_detail', params: { id: params.row.server_id } })
                }
              }
            }, resourceIdTransName('servers', params.row.server_id))
          }
        },
        {
          title: '挂载点',
          align: 'center',
          minWidth: 150,
          tooltip: true,
          key: 'device'
        },
        {
          title: '操作',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            return h('Poptip', {
              props: {
                transfer: true,
                confirm: true,
                placement: 'bottom',
                width: 200,
                title: '你确定要把云硬盘从该实例中分离吗？分离后数据会保留在云硬盘上，可被其他挂载了该云硬盘的实例读取。'
              },
              on: {
                'on-ok': () => {
                  this.detach(params.row.attachment_id, params.row.server_id)
                }
              }
            }, [
              h('Button', {
                props: {
                  loading: this.detachLoading,
                  type: 'error',
                  size: 'small'
                }
              }, '分离卷')
            ])
          }
        }
      ],
      detachLoading: false,
      link_data: [],
      serverList: [],
      reqForm: {
        instance_uuid: '',
        mountpoint: ''
      },
      reqRule: {
        instance_uuid: [
          { required: true, message: '请选择实例', trigger: 'change' }
        ],
        mountpoint: [
          { required: true, message: '挂载点不能为空', trigger: 'blur' }
        ]
      },
      errorMsg: '',
      errorMsgShow: false
    }
  },
  methods: {
    openModal (id) {
      this.reqForm.instance_uuid = ''
      this.reqForm.mountpoint = ''
      detailPrivateCloudVolume(id).then(res => {
        this.volumeData = res.data.volume
        this.link_data = this.volumeData.attachments
        this.getServerList()
        this.modalShow = true
      })
    },
    // 获取实例列表
    getServerList () {
      let params = {
        project_id: this.$store.state.privateCloud.selPrivateCloudProject
      }
      getPrivateCloudAllServer(params).then(res => {
        this.serverList = res.data
      }).catch(res => {
        this.$Notice.error({
          title: '获取实例列表失败！'
        })
      })
    },
    submit () {
      this.$refs['reqForm'].validate((valid) => {
        if (valid) {
          let reqData = {
            'os-attach': this.reqForm
          }
          this.submitting = true
          actionPrivateCloudVolume(reqData, this.volumeData.id).then(res => {
            this.modalShow = false
            this.$Notice.success({
              title: '操作成功！'
            })
            this.submitting = false
            this.$emit('callback')
          }).catch(res => {
            this.submitting = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！'
              this.$Notice.error({
                title: '操作失败！'
              })
            }
            this.errorMsgShow = true
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    },
    detach (id, serverId) {
      let reqData = {
        'os-detach': {
          attachment_id: id,
          server_id: serverId
        }
      }
      this.detachLoading = true
      actionPrivateCloudVolume(reqData, this.volumeData.id).then(res => {
        this.modalShow = false
        this.$Notice.success({
          title: '操作成功！'
        })
        this.detachLoading = false
        this.$emit('callback')
      }).catch(res => {
        this.detachLoading = false
        if (res.request) {
          this.errorMsg = res.request.responseText
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.errorMsg = '操作失败！'
          this.$Notice.error({
            title: '操作失败！'
          })
        }
        this.errorMsgShow = true
      })
    }
  }
}
</script>

<style scoped>
  .req-form {
    max-height: 650px;
    overflow-y: auto;
  }
  .req-form::-webkit-scrollbar {
    width: 5px;
  }
  .req-form::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .req-form::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
